/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getResult } from '../fn/site-search-api/get-result';
import { GetResult$Params } from '../fn/site-search-api/get-result';
import { SearchResult } from '../models/search-result';

@Injectable({ providedIn: 'root' })
export class SiteSearchApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getResult()` */
  static readonly GetResultPath = '/api/results';

  /**
   * Returns the search result with all related data
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getResult()` instead.
   *
   * This method doesn't expect any request body.
   */
  getResult$Response(params?: GetResult$Params, context?: HttpContext): Observable<StrictHttpResponse<SearchResult>> {
    return getResult(this.http, this.rootUrl, params, context);
  }

  /**
   * Returns the search result with all related data
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getResult$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getResult(params?: GetResult$Params, context?: HttpContext): Observable<SearchResult> {
    return this.getResult$Response(params, context).pipe(
      map((r: StrictHttpResponse<SearchResult>): SearchResult => r.body)
    );
  }

}
